export default "__VITE_ASSET__b3b8047a__"